export const currencyFormatter = (amount, storeCurrency) => {
  // console.log(amount, storeCurrency)
    if(storeCurrency?.currencyPosition === "suffix"){
      return `${amount} ${storeCurrency?.symbol}`;
    }
    else{
      return `${storeCurrency?.symbol} ${amount}`;
    }
  };
